"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchCorrectionStatus = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const luxon_1 = require("luxon");
const Button_1 = require("@amzn/atoz-web/Button");
const Col_1 = require("@amzn/atoz-web/Col");
const Row_1 = require("@amzn/atoz-web/Row");
const View_1 = require("@amzn/atoz-web/View");
const Text_1 = require("@amzn/atoz-web/Text");
const Spinner_1 = require("@amzn/atoz-web/Spinner");
const Icons_1 = require("@amzn/atoz-web/Icons");
const Flyout_1 = require("@amzn/atoz-web/Flyout");
const Theme_1 = require("@amzn/atoz-web/Theme");
const Responsive_1 = require("@amzn/atoz-web/Responsive");
const EmptyClock_web_1 = require("../Shared/EmptyClock/EmptyClock.web");
const logger_1 = require("../../logger");
const StatusOverview_1 = require("./StatusOverview");
const PunchStatusModal_1 = require("./PunchStatusModal");
const PunchCorrectionStatusTypes_1 = require("./PunchCorrectionStatusTypes");
const usePunchCorrectionStatus_1 = require("./hooks/usePunchCorrectionStatus");
const hooks_1 = require("../../hooks");
const taaConfigs_1 = require("../../contexts/taaConfigs");
const fetchUtils_1 = require("../../client/fetchUtils");
const PunchCorrectionStatus = ({ isLoading, punchCorrStatusList, start, end, fetchPunchCorrList }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const seePunchCorrStatusBtnRef = (0, react_1.useRef)(null);
    const searchParams = (0, hooks_1.useSearchParams)();
    (0, react_1.useEffect)(() => {
        var _a;
        if (((_a = searchParams.get(PunchCorrectionStatusTypes_1.ViewPunchCorrectionStatusUrlParam)) === null || _a === void 0 ? void 0 : _a.toString()) === 'true') {
            seePunchCorrStatusBtnRef.current.click();
        }
    }, [searchParams]);
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: logger_1.METRICS.PUNCH_CORR_STATUS_LIST.COUNT,
            latencyMetricName: logger_1.METRICS.PUNCH_CORR_STATUS_LIST.LATENCY
        },
        isComponentLoaded: !isLoading
    });
    const { associateInfo, currentStage } = (0, taaConfigs_1.useTaaConfigsContext)();
    const isNonProdEnv = currentStage !== fetchUtils_1.Stage.PROD;
    const { matches } = (0, Responsive_1.useBreakpoints)();
    const isMobileViewPort = !!matches.s;
    const { isInDetailsView, isShowMore, setIsShowMore, clickedItem, setClickedId, sortedPunchCorrList } = (0, usePunchCorrectionStatus_1.usePunchCorrectionStatus)({ punchCorrStatusList });
    const renderTitle = ({ titleText }) => {
        const titleComp = (react_1.default.createElement(Text_1.Text, { color: "neutral0", fontSize: "T400", lineHeight: "48px" }, titleText));
        if (isInDetailsView) {
            return (react_1.default.createElement(Row_1.Row, { alignItems: "center" },
                react_1.default.createElement(BackButton, { dataTestId: "BackButton", variant: Button_1.ButtonVariant.Tertiary, onClick: () => setClickedId(null), icon: react_1.default.createElement(Icons_1.IconArrowLeft, { title: t('time_and_attendance_PunchCorrStatus_Back') }) }),
                titleComp));
        }
        return titleComp;
    };
    const closeFlyout = (close) => {
        close();
        setClickedId(null);
        setIsShowMore(false);
        searchParams.delete(PunchCorrectionStatusTypes_1.ViewPunchCorrectionStatusUrlParam);
        window.history.replaceState(null, null, `${window.location.pathname}${searchParams.toString() ? '?' + searchParams.toString() : ''}`);
    };
    const renderFlyout = ({ close }) => (react_1.default.createElement(Flyout_1.FlyoutContent, { dataTestId: "PunchCorrStatusFlyoutContent", onCloseButtonClick: () => closeFlyout(close), titleText: isInDetailsView
            ? t('time_and_attendance_PunchCorrStatus_Back')
            : t('time_and_attendance_PunchCorrStatus_HeaderTitle'), renderTitle: renderTitle, buttons: [
            react_1.default.createElement(Button_1.Button, { key: "PunchCorrStatusFlyoutCloseButton", variant: Button_1.ButtonVariant.Primary, onClick: () => closeFlyout(close), dataTestId: "PunchCorrStatusFlyoutClose" }, t('time_and_attendance_PunchCorrStatus_Close'))
        ] },
        react_1.default.createElement(ContentContainer, { isMobileViewPort: isMobileViewPort },
            !isInDetailsView && (react_1.default.createElement(Col_1.Col, null,
                react_1.default.createElement(Text_1.Text, null, t('time_and_attendance_PunchCorrStatus_CurrentRequests')),
                react_1.default.createElement(Text_1.Text, null, `${start.toLocaleString(luxon_1.DateTime.DATE_FULL)} - ${end.toLocaleString(luxon_1.DateTime.DATE_FULL)}`))),
            isLoading && (react_1.default.createElement(CentralContainer, { dataTestId: "PunchCorrStatusSpinner" },
                react_1.default.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.Small }))),
            !isLoading && sortedPunchCorrList.length === 0 && (react_1.default.createElement(CentralContainer, { dataTestId: "PunchCorrStatusNoPunchRequests" },
                react_1.default.createElement(StyledClock, { alt: "Empty Clock" }),
                react_1.default.createElement(Text_1.Text, { textAlign: "center", fontSize: "T300" }, t('time_and_attendance_PunchCorrStatus_NoRequests')))),
            !isLoading && !isInDetailsView && (react_1.default.createElement(react_1.Fragment, null,
                (isShowMore
                    ? sortedPunchCorrList
                    : sortedPunchCorrList.slice(0, 10)).map((item) => {
                    let dateTime, initialDateTime;
                    if (item.requestType === PunchCorrectionStatusTypes_1.PunchCorrType.EDIT_PUNCH) {
                        dateTime = item.newPunchDateTime;
                        initialDateTime = item.punchDateTime;
                    }
                    else {
                        dateTime = item.punchDateTime;
                    }
                    return (react_1.default.createElement(StatusOverview_1.StatusOverview, { key: item.requestId, status: item.status, reason: item.reasonCode, type: item.requestType, dateTime: dateTime, initialDateTime: initialDateTime, showStatusDetails: () => setClickedId(item.requestId) }));
                }),
                sortedPunchCorrList.length > 10 && (react_1.default.createElement(Button_1.Button, { dataTestId: "SeeMoreButton", variant: Button_1.ButtonVariant.Primary, onClick: () => setIsShowMore(!isShowMore) }, t(isShowMore
                    ? 'time_and_attendance_PunchCorrStatus_SeeLess'
                    : 'time_and_attendance_PunchCorrStatus_SeeMore'))))),
            !isLoading && isInDetailsView && !!clickedItem && (react_1.default.createElement(PunchStatusModal_1.PunchStatusModal, { employeeId: associateInfo.employeeId, status: clickedItem.status, reason: clickedItem.reasonCode, type: clickedItem.requestType, dateTime: clickedItem.requestType === PunchCorrectionStatusTypes_1.PunchCorrType.EDIT_PUNCH
                    ? clickedItem.newPunchDateTime
                    : clickedItem.punchDateTime, initialDateTime: clickedItem.requestType === PunchCorrectionStatusTypes_1.PunchCorrType.EDIT_PUNCH
                    ? clickedItem.punchDateTime
                    : null, referenceId: clickedItem.referenceId, canRenderSubmitReviewRequest: isNonProdEnv, isCardLayout: true })))));
    const openFlyout = (open) => {
        open();
        fetchPunchCorrList();
    };
    return (react_1.default.createElement(Flyout_1.WithFlyout, { renderFlyout: renderFlyout }, ({ open }) => (react_1.default.createElement(Button_1.Button, { dataTestId: "SeePunchCorrStatus", onClick: () => openFlyout(open), variant: Button_1.ButtonVariant.Tertiary, ref: seePunchCorrStatusBtnRef }, t('time_and_attendance_PunchCorrStatus_SeePunchCorrStatus')))));
};
exports.PunchCorrectionStatus = PunchCorrectionStatus;
const BackButton = (0, Theme_1.styledWithTheme)(Button_1.Button)(({ theme }) => `
    color: ${theme.selectors.color('neutral0')};
    margin-right: ${theme.selectors.space('S100')}px;
    &:focus {
      border-color: ${theme.selectors.color('neutral0')};
    }

    &:focus:before {
      border-color: transparent;
    }
`);
const StyledClock = (0, Theme_1.styledWithTheme)(EmptyClock_web_1.EmptyClock)(({ theme }) => `
    margin: ${theme.selectors.space('S400')}px 0;
`);
const ContentContainer = (0, Theme_1.styledWithTheme)(Col_1.Col)(({ theme, isMobileViewPort }) => `
      width: ${isMobileViewPort ? 'calc(100vw - 32px)' : '400px'};
      gap: ${theme.selectors.space('S400')}px;
      > div:not(:last-of-type) {
        border-bottom: 1px solid ${theme.selectors.color('neutral10')};
        padding-bottom: ${theme.selectors.space('S400')}px;
      }
  `);
const CentralContainer = (0, Theme_1.styledWithTheme)(View_1.View)(`
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  `);
